import type {ErrorMessage} from 'angular-error-repository';

export const FqdnNumberError: ErrorMessage = err => {
    return `Error.FQDN.${err.error}`;
};
